module.exports = __webpack_public_path__ + "media/images/help-center/help-center-icon-legal-a936560eb2261d530f809c552b116152.png";